export const styles = () => `.addressColumnWidth {
width: 20%;
}
`;
